import createLucideIcon from '../createLucideIcon';

const ChevronLeft = createLucideIcon('ChevronLeftIcon', [
  ['path', { d: 'm15 18-6-6 6-6', key: '1wnfg3' }],
]);

export default ChevronLeft;
